import {extrasController,giftBoxControl,markedBox,enhanceClearanceOffer} from './aa-offer-extras.js?v=20261030-lander-packaging';
import {offerItems,hasOfferDiscount} from './aa-offer-cart.js?v=aa-extras-20261019-1';
import {currencyContext} from './aa-offer-currency.js?v=aa-extras-20261019-1';
/* Draft storefront helper: never changes cart totals or prices. Shopify is authoritative. */
const rulesCache=new Map();
const refreshNativeCart=()=>{if(/\/cart\/?$/.test(location.pathname))location.reload();else document.dispatchEvent(new CustomEvent('cart:refresh'));};
const getRules=url=>{
 if(!rulesCache.has(url))rulesCache.set(url,fetch(url).then(r=>{if(!r.ok)throw Error('Offer configuration unavailable');return r.json();}));
 return rulesCache.get(url);
};
class AAOfferProgress extends HTMLElement {
 connectedCallback(){
  this.controller?.abort();this.controller=new AbortController();
  this.revision=0;
  const initial=this.querySelector('[data-offer-cart]');
  try{this.render(JSON.parse(initial?.textContent||'{}'));}catch{this.hidden=true;}
  document.addEventListener('cart:change',e=>this.render(e.detail?.cart),{signal:this.controller.signal});
  document.addEventListener('cart:refresh',()=>this.refresh(),{signal:this.controller.signal});
 }
 disconnectedCallback(){this.controller?.abort();this.revision++;}
 async refresh(){
  try{const r=await fetch(`${window.Shopify?.routes?.root||'/'}cart.js`,{headers:{Accept:'application/json'}});if(r.ok)await this.render(await r.json());}catch{this.hidden=true;}
 }
 async render(cart){
  const revision=++this.revision;
  try{
   const config=await getRules(this.dataset.config);
   if(!this.isConnected||revision!==this.revision)return;
   this.extras=extrasController(config,value=>offerItems(value,config,currencyContext(config,value.currency)));
   if(!this.syncing&&(offerItems(cart,config).length||cart.items?.some(markedBox))){this.syncing=true;try{const result=await this.extras.reconcile(cart,{activate:true});cart=result.cart;if(result.changed){refreshNativeCart();}}finally{this.syncing=false;}}
   if(!this.isConnected||revision!==this.revision)return;
   const context=currencyContext(config,cart.currency),bundle=context.offerMoney(context.offerBundleCents);
   enhanceClearanceOffer({cart,context,controller:this.extras,onChange:async cart=>{await this.render(cart);refreshNativeCart();}});
   const qualifying=offerItems(cart,config,context);
   const quantity=qualifying.reduce((n,item)=>n+item.quantity,0);
   this.hidden=!quantity&&!this.hasAttribute('data-force-visible');
   const applied=hasOfferDiscount(cart);
   const needed=Math.max(0,4-quantity);
   let message;
   if(quantity<4)message=`Add ${needed} more ${needed===1?'piece':'pieces'} for 4 for ${bundle}.`;
   else if(applied)message=`First four ${bundle}${quantity>4?` + ${quantity-4} extra ${quantity===5?'piece':'pieces'} at ${context.money(context.premium(2000))} each`:''}.`;
   else message='Four eligible pieces selected. Check the offer in your cart before checkout.';
   this.querySelector('[role=status]').textContent=message;
   const progress=this.querySelector('progress');progress.value=Math.min(quantity,4);
   let host=this.querySelector("[data-led-boxes]");if(!host){host=document.createElement("div");host.dataset.ledBoxes="";host.className="aa-offer-box-control";this.append(host);}
   giftBoxControl({host,cart,context,controller:this.extras,onChange:async cart=>{await this.render(cart);refreshNativeCart();}});
  }catch{if(revision===this.revision)this.hidden=true;}
 }
}
if(!customElements.get('aa-offer-progress'))customElements.define('aa-offer-progress',AAOfferProgress);
